import { LoginItem, ScriptConfig } from '@script/types'

import { WidgetEventType } from './lib/api/events/types'

export enum DataAttribute {
  BANK_INSTRUCTIONS = 'bank_instructions',
  BANK_SCREEN_CONTACT_INFO = 'bank_screen_contact_info',
  BTN_ADD_EMPLOYED_INCOME = 'btn_add_employed_income',
  BTN_ADD_OTHER_INCOME = 'btn_add_other_income',
  BTN_CLOSE = 'btn_close',
  BTN_CONSENT = 'btn_consent',
  BTN_CONTINUE_TO_VERIFIER = 'btn_continue_to_verifier',
  BTN_COPY_ERROR = 'btn_copy_error',
  BTN_EXIT = 'btn_exit',
  BTN_GO_BACK = 'btn_go_back',
  BTN_REMOVE_FILE = 'btn_remove_file',
  BTN_SUBMIT_FILES = 'btn_submit_files',
  BTN_UPLOAD_FILES = 'btn_upload_files',
  DIALOG = 'dialog',
  DOCUMENTS_LIST = 'documents_list',
  DOCUMENTS_SCREEN_UPLOAD_STEP = 'documents_screen_upload_step',
  EDIT_INFORMATION_BUTTON = 'edit_information_button',
  EMPLOYER_NOT_FOUND_QUIT_BUTTON = 'employer_not_found_quit_button',
  EMPLOYER_NOT_FOUND_SCREEN = 'employer_not_found_screen',
  EMPLOYER_NOT_FOUND_SEARCH_AGAIN_BUTTON = 'employer_not_found_search_again_button',
  FEEDBACK_OPTION = 'feedback_option',
  FEEDBACK_OTHER_INPUT = 'feedback_other_input',
  FEEDBACK_OTHER_OPTION = 'feedback_other_option',
  FEEDBACK_SCREEN = 'feedback_screen',
  FEEDBACK_SUBMIT_BUTTON = 'feedback_submit_button',
  FILE_UPLOAD_ERROR = 'file_upload_error',
  FILE_UPLOAD_STATE_ICON_LOADING = 'file_upload_state_icon_loading',
  FILE_UPLOAD_STATE_ICON_ERROR = 'file_upload_state_icon_error',
  FILE_UPLOAD_STATE_ICON_SUCCESS = 'file_upload_state_icon_success',
  FILE_UPLOADER = 'file_uploader',
  FOOTER = 'footer',
  FRAME_TW_JS = 'frame_tw_js',
  HEADER = 'header',
  HEADER_NO_NAVIGATION = 'header_no_navigation',
  HEADER_BTN_BACK = 'header_btn_back',
  HEADER_BTN_CANCEL = 'header_btn_cancel',
  LOGO = 'logo',
  PARTNER_SCREEN_ARGYLE = 'partner_screen_argyle',
  PARTNER_SCREEN_SANDBOX_FORM = 'partner_screen_sandbox_form',
  PARTNER_SCREEN_SANDBOX_FORM_PASSWORD = 'partner_screen_sandbox_form_password',
  PARTNER_SCREEN_SANDBOX_FORM_SUBMIT = 'partner_screen_sandbox_form_submit',
  PARTNER_SCREEN_SANDBOX_FORM_USERNAME = 'partner_screen_sandbox_form_username',
  PARTNER_SCREEN_SANDBOX_SEARCH = 'partner_screen_sandbox_search',
  PARTNER_SCREEN_SANDBOX_SEARCH_POPULAR_COMPANIES = 'partner_screen_sandbox_search_popular_companies',
  POS_ADD_EMPLOYER_SAVE_BUTTON = 'pos_add_employer_save_button',
  POS_COMPANIES_LIST = 'companies_list',
  POS_COMPANY_SEARCH_RESULT = 'company_search_result',
  POS_COMPLETE_BUTTON = 'pos_complete_button',
  POS_COMPLETE_SCREEN = 'pos_complete_screen',
  POS_CURRENT_JOB_CHECKBOX = 'current_job_checkbox',
  POS_EMPLOYER_NAME_INPUT = 'pos_employer_name_input',
  POS_EMPLOYERS_LIST = 'pos_employers_list',
  POS_EMPLOYMENT_DETAILS_SCREEN = 'pos_employment_details_screen',
  POS_END_DATE_INPUT = 'pos_end_date_input',
  POS_INCOME_INPUT = 'pos_income_input',
  POS_JOB_TITLE_INPUT = 'pos_job_title_input',
  POS_SAVE_STATED_INFORMATION_BUTTON = 'pos_save_stated_information_button',
  POS_SCREEN_COMPANY_DETAILS = 'pos_screen_company_details',
  POS_CHECK_PLATFORM = 'pos_check_platform',
  POS_SCREEN_TASKS = 'pos_screen_tasks',
  POS_SCREEN_SELECT_INCOME_TYPE = 'pos_screen_select_income_type',
  POS_SCREEN_SELECT_VERIFICATION_METHOD = 'pos_screen_select_verification_method',
  POS_SCREEN_SELECET_BANK_OR_EMPLOYMENT = 'pos_screen_select_bank_or_employment',
  POS_TAX_LINK = 'pos_tax_link',
  LABEL_TAG = 'label_tag',
  CONSENT_TERMS = 'consent_terms',
  CONSENT_PRIVACY_POLICY = 'consent_privacy_policy',
  POS_START_DATE_INPUT = 'pos_start_date_input',
  POS_STATED_INFORMATION_SCREEN = 'pos_stated_information_screen',
  POWERED_BY_TRUEWORK = 'powered_by_truework',
  SCREEN_CONFIRM_EXIT = 'screen_confirm_exit',
  SCREEN_CONSENT = 'screen_consent',
  SCREEN_TASKS = 'screen_tasks',
  SCREEN_ERROR = 'screen_error',
  SCREEN_EXIT = 'screen_exit',
  SCREEN_TERMINAL_COMPLETE = 'screen_terminal_complete',
  SCREEN_TERMINAL_COMPLETE_BY_OTHER_STRATEGY = 'screen_terminal_complete_by_other_strategy',
  SCREEN_TERMINAL_EXPIRED = 'screen_terminal_expired',
  SCREEN_TERMINAL_FAILED = 'screen_terminal_failed',
  SCREEN_TERMINAL_FALLBACK = 'screen_terminal_fallback',
  SCREEN_WAITING_FOR_INSTANT_DATA = 'screen_waiting_for_instant_data',
  SELF_STATE_INFORMATION_BUTTON = 'self_state_information_button',
  UPLOAD_STEP_CONTENT = 'upload_step_content',
  VERIFY_VIA_CREDENTIALS_BUTTON = 'verify_via_credentials_button',
  VERIFY_VIA_DOCUMENTS_BUTTON = 'verify_via_documents_button',
  VERIFY_VIA_BANK_BUTTON = 'verify_via_bank_button',
  VERIFY_VIA_EMPLOYMENT_BUTTON = 'verify_via_employment_button',
  BTN_SUBMIT_EMPLOYER_HISTORY = 'btn_submit_employer_history',
  ERROR_IMAGE = 'error_image',
  SCREEN_LOADING = 'screen_loading',
  SCREEN_UNIFIED_SEARCH = 'screen_unified_search',
  UNIFIED_SEARCH_RESULTS = 'unified_search_results',
  UNIFIED_SEARCH_INPUT = 'unified_search_input',
  UNIFIED_SEARCH_FOOTER = 'unified_search_footer',
  UNIFIED_SEARCH_LINK = 'unified_search_link',
  UNIFIED_SEARCH_LINK_NAME = 'unified_search_link_name',
  UNIFIED_SEARCH_LINK_DETAIL = 'unified_search_link_detail',
  SCREEN_FEEDBACK_COMPLETE = 'screen_feedback_complete',
  UNIFIED_SEARCH_CONFIRM_EMPLOYER = 'unified_search_confirm_employer',
  SCREEN_CONNECTION_ERROR = 'screen_connection_error',
  EXIT_PROMPT_SUBMIT = 'exit_prompt_submit',
  EXIT_PROMPT_FINISH_LATER = 'exit_prompt_finish_later',
  EXIT_PROMPT_START_OVER = 'exit_prompt_start_over',
  EMPLOYMENT_CARD = 'employment_card',
  EMPLOYMENT_CARD_TITLE = 'employment_card_title',
  EMPLOYMENT_CARD_DETAIL = 'employment_card_detail',
  COBRANDING_LOGO = 'cobranding_logo',
  CONSENT_CARD = 'consent_card',
  ADD_EMPLOYER = 'add_employer',
  KNOWN_PAYROLL = 'known_payroll',
  UNKNOWN_PAYROLL = 'unknown_payroll',
  BTN_SKIP_EMPLOYER = 'btn_skip_employer',
  COMPLETE_SCREEN_CONTENT = 'complete_screen_content',
  NO_EMPLOYER_ADDRESS_CHECKBOX = 'no_employer_address_checkbox',
  WEEKLY_HOURS_INPUT = 'weekly_hours_input',
  PAY_UNIT_ANNUALLY = 'pay_unit_annually',
  PAY_UNIT_HOURLY = 'pay_unit_hourly',
  PAY_UNIT_OTHER = 'pay_unit_other',
  ADDRESS_OPTIONS = 'address_options',
  BTN_MISSING_PAYSTUBS = 'btn_missing_paystubs',
  IRS_FULL_NAME_INPUT = 'irs_full_name_input',
  ADDRESS_INPUT = 'address_input',
  IRS_FORM = 'irs_form',
  SCREEN_INCOME_ONLY_TASKS = 'screen_income_only_tasks',
  CONNECT_BANK_CARD = 'connect_bank_card',
  EMPLOYER_HISTORY_CARD = 'employer_history_card',
  CONNECT_BANK_BTN = 'connect_bank_btn',
  TENANT_SCREENING_TASKS = 'tenant_screening_tasks',
  SCREEN_IDENTIFY_INCOME = 'screen_identify_income',
  SCREEN_IDENTIFY_INCOME_LOADING = 'screen_identify_income_loading',
  SCREEN_BANK_CONNECTED_TASKS = 'screen_bank_connected_tasks',
  LOADING_BAR = 'loading_bar',
  BANK_PHONE_NUMBER_INPUT = 'bank_phone_number_input',
  SCREEN_PAYSTUB_INFORMATION = 'screen_paystub_information',
  SCREEN_W2_INFORMATION = 'screen_w2_information',
  INFORMATION_CARD = 'information_card',
  RADIO_GROUP = 'radio_group',
  SLIDE_UP_POPOVER_OVERLAY = 'slide_up_popover_overlay',
  SLIDE_UP_POPOVER = 'slide_up_popover',

  DOCUMENTS_SCREEN_SELECT_DOCUMENT_TYPE = 'documents_screen_select_document_type',
  DOCUMENTS_SCREEN_UPLOAD_DOCUMENTS = 'documents_screen_upload_documents',
  DOCUMENTS_SCREEN_ALTERNATIVE_METHODS = 'documents_screen_alternative_methods',
  DOCUMENTS_SCREEN_SELECT_OTHER_DOCUMENT_TYPES = 'documents_screen_select_other_document_types',
  DOCUMENTS_CONFIRM_SUBMISSION = 'documents_confirm_submission',
  DOCUMENTS_REMOVE_DOCUMENT_POPOVER = 'documents_remove_document_popover',
  DOCUMENTS_REMOVE_DOCUMENT_CONFIRM_BUTTON = 'documents_remove_document_confirm_button',
  DOCUMENTS_REMOVE_DOCUMENT_CANCEL_BUTTON = 'documents_remove_document_cancel_button',
}

export enum PrimitiveDataAttribute {
  TW_PRIMITIVE_H1 = 'tw_primitive_h1',
  TW_PRIMITIVE_H2 = 'tw_primitive_h2',
  TW_PRIMITIVE_H3 = 'tw_primitive_h3',
  TW_PRIMITIVE_H4 = 'tw_primitive_h4',
  TW_PRIMITIVE_H5 = 'tw_primitive_h5',
  TW_PRIMITIVE_H6 = 'tw_primitive_h6',
  TW_PRIMITIVE_P = 'tw_primitive_p',
  TW_PRIMITIVE_SPAN = 'tw_primitive_span',
  TW_PRIMITIVE_CARD = 'tw_primitive_card',
  TW_PRIMITIVE_WIDGET = 'tw_primitive_widget',
}

export enum BaseDataAttribute {
  PROGRESS_CIRCLE = 'progress_circle',
  PROGRESS_CIRCLE_TRACK = 'progress_circle_track',
  PROGRESS_CIRCLE_INDICATOR = 'progress_circle_indicator',
  PROGRESS_CIRCLE_LABEL = 'progress_circle_label',
}

export enum DocumentCardDataAttribute {
  CARD = 'card',
  ICON = 'icon',
  DELETE_BUTTON = 'delete_button',
  CLASSIFICATION = 'classification',
  TYPE_SELECTOR = 'type_selector',
  FAILURE_MESSAGE = 'failure_message',
  RETRY_UPLOAD_BUTTON = 'retry_upload_button',
}

export type BasicPartnerEventPayload = {
  event_name: WidgetEventType
  internal_metadata?: {
    referrer?: string
  }
  [key: string]: unknown
}

export type FrameConfig = ScriptConfig & { instanceId: string; loginItemIds?: LoginItem[] }
